const initialState = {
  datos: {},
  loading: true,
  error: null,
  status: null,
  filters: {
    date: {
      fechaStartFinal: null,
      fechaEndFinal: null
    },
    tags: [],
    hasRisk: 'All'
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/detail_fatigue/initialState.js